function ArchiveFilter(filter) {
    const title = filter.querySelector('.jsArchiveFilterTitle');
    const expandWrapper = filter.querySelector('.jsArchiveFilterExpandWrapper');

    title.addEventListener('click', () => {
        if (!expandWrapper.classList.contains('open')) {
            title.classList.add('active');

            TweenLite.set(expandWrapper, { display: 'block', opacity: 0 });
            const height = expandWrapper.offsetHeight;
            TweenLite.set(expandWrapper, { height: 0, opacity: 1 });
            TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: () => {
                expandWrapper.classList.add('open');
                TweenLite.set(expandWrapper, { clearProps: 'all' });
            } });
        }
        else {
            title.classList.remove('active');

            TweenLite.to(expandWrapper, 0.5, { height: 0, ease: Power2.easeInOut, onComplete: () => {
                expandWrapper.classList.remove('open');
                expandWrapper.classList.remove('open-children');

                TweenLite.set(expandWrapper, { clearProps: 'all' });
            } });
        }     
    });
}